import { render } from "./gif-search.vue?vue&type=template&id=36bde41a&scoped=true&lang=pug"
import script from "./gif-search.vue?vue&type=script&lang=js"
export * from "./gif-search.vue?vue&type=script&lang=js"

import "./gif-search.vue?vue&type=style&index=0&id=36bde41a&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36bde41a"]])

export default __exports__